import {useEffect} from "react";
import {postTopicRead} from "../utils/api";
import {userLoginKey, classListKey, selectClassTitle} from "../config";
import {useNavigate} from "react-router-dom";
import {Col, Row, Card} from "react-bootstrap";
import {getQueryString} from "../utils/utils";
import axios from "axios";
import Meta from "../components/Meta";
import camera28 from '../assets/img/camera28.png';
import uds28 from '../assets/img/uds28.png';
import rating28 from '../assets/img/rating28.png';

const ClassSecond = () => {
  const navigate = useNavigate();
  const id = getQueryString("id")
  const classList = JSON.parse(sessionStorage.getItem(classListKey))
  const initClass = classList.find(item => item.id === id)

  useEffect(() => {
    let isUnmounted = false
    if (sessionStorage.getItem(userLoginKey) === null && !isUnmounted) {
      navigate("/")
    }

    return () => isUnmounted = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleClass = (event, itemTopic) => {
    event.preventDefault();
    //
    postTopicRead(itemTopic).then();
    window.open(itemTopic.urlVideo, '_blank', 'noopener,noreferrer');
  }

  const handleTest = (event, item, itemSub, folderId) => {
    event.preventDefault();
    sessionStorage.setItem(selectClassTitle, item + " " + itemSub)
    navigate("/classTest?folderId=" + folderId)
  }

  const handleValue = (event, item, itemSub, folderId) => {
    event.preventDefault();
    sessionStorage.setItem(selectClassTitle, item + " " + itemSub)
    navigate("/classValue?folderId=" + folderId)
  }

  return (
    <main id="main">
      <Meta title={"課程單元-"+ initClass.name}/>
      <section className="breadcrumbs">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <h2 aria-current="page">{initClass.id}.{initClass.name}</h2>
            <ol aria-label="Breadcrumb" role="navigation">
              <li><a href="/classFirst" title="回到課程列表" role="button" tabIndex="1">回到課程列表</a></li>
            </ol>
          </div>
        </div>
      </section>
      <a className="accesskey" href="#aC" id="aC" accessKey="C" title="中間功能區塊" tabIndex="1">:::</a>
      <section id="class-second" className="class-second">
        <div className="container">
          <div className="row gy-4">
            {initClass.subjectList.map((item, index) => (
              <div className="px-3 col-lg-6" key={`class-second-01-${index}`}>
                <Card border="success">
                  <Card.Header className="">{item.id}.{item.name}</Card.Header>
                  <Card.Body>
                    <Row>
                      {!!(item.urlVideo) ?
                          <Col className="text-center" key={`class-second-02-${index}`}> <a href="" key={"item" + index}
                                                                                          role="button"
                                                                                          tabIndex="1"
                                                                                          title={"開啟課程-" + item.name + "的影片播放視窗（另開新視窗）"}
                                                                                          className="card-link me-lg-3"
                                                                                          onClick={(e) => handleClass(e, item)}><img src={camera28} alt="影片圖示"/>&nbsp;開啟本課程影片</a></Col>
                        : <Col className="text-center" key={`class-second-02-${index}`}><img src={uds28} alt="建置中圖示"/>&nbsp;課程影片建置中...</Col>
                      }
                      <Col className="text-center">
                        <a href="" role="button" title={"前往" + item.name + "之單元評分"} className="card-link me-lg-3" tabIndex="1"
                           onClick={(e) => handleValue(e, `${initClass.id}.${initClass.name}`, `${item.id}.${item.name}`, item.folderId)}><img src={rating28} alt="單元評分圖示"/>&nbsp;針對本單元評分</a>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </div>
            ))}

          </div>
        </div>
      </section>
    </main>
  )
}

export default ClassSecond
